// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3ctFT","buttons":"SendReceipts_buttons__tLg8u","email":"SendReceipts_email__3WpMu","bookApptTitle":"SendReceipts_bookApptTitle__3YMHr"};